export default __webpack_public_path__ + "static/media/(89).b5f6046c.jpg";